// extracted by mini-css-extract-plugin
export default {"box2":"skills_box2__FL8+e","icon":"skills_icon__3FY+V","skillflex":"skills_skillflex__yxgTO","name":"skills_name__Mm2Qo","deg":"skills_deg__ARRjU"};